export const MEOW_TOKEN_ADDRESS = '0x6ce4a22AA99F9ae41D27E1eC3f40c32b8D0C3113';
export const MEOW_ZEPHYR_TOKEN_ADDRESS = '0xA10a8D70EfD4593Cfe7BD6F417211103f610267E';
export const VMEOW_TOKEN_ADDRESS = '0x8C942834fEd85070B41B71963C54c4CDFd10189D';
